import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=6c90fd4b&scoped=true&"
import script from "./grid.vue?vue&type=script&lang=ts&"
export * from "./grid.vue?vue&type=script&lang=ts&"
import style0 from "./grid.vue?vue&type=style&index=0&id=6c90fd4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90fd4b",
  null
  
)

export default component.exports